(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('budgetheld-live-search')) {
    class BudgetheldLiveSearch extends HTMLElement {
      constructor() {
        super();
        this.abortController = null;
        this.debounceTimer = null;
        this.cache = new Map();
        this.lastQuery = '';
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.panel = this.querySelector('.bh-live-search__panel');
        this.status = this.querySelector('.bh-live-search__status');
        this.rootUrl = this.dataset.rootUrl || '/';
        this.searchUrl = this.dataset.searchUrl || '/search';
        this.maxResults = Math.min(8, Math.max(3, Number(this.dataset.maxResults) || 5));
        this.minChars = Math.min(3, Math.max(1, Number(this.dataset.minChars) || 2));

        this.onInput = this.onInput.bind(this);
        this.onInputPointerDown = this.onInputPointerDown.bind(this);
        this.onInputSelectStart = this.onInputSelectStart.bind(this);
        this.onInputDoubleClick = this.onInputDoubleClick.bind(this);
        this.onInputKeydown = this.onInputKeydown.bind(this);
        this.onPanelKeydown = this.onPanelKeydown.bind(this);
        this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onResize = this.onResize.bind(this);

        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('search', this.onInput);

        /* Laat het zoekveld zelf eigenaar blijven van tekstselectie.
           We stoppen alleen bubbling; de normale browserselectie blijft toegestaan. */
        this.input.addEventListener('pointerdown', this.onInputPointerDown);
        this.input.addEventListener('mousedown', this.onInputPointerDown);
        this.input.addEventListener('selectstart', this.onInputSelectStart);
        this.input.addEventListener('dblclick', this.onInputDoubleClick);

        this.input.addEventListener('keydown', this.onInputKeydown);
        this.panel.addEventListener('keydown', this.onPanelKeydown);
        document.addEventListener('pointerdown', this.onDocumentPointerDown);
        this.addEventListener('focusout', this.onFocusOut);
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('scroll', this.onResize, { passive: true });

        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', this.onResize, { passive: true });
        }
      }

      disconnectedCallback() {
        clearTimeout(this.debounceTimer);
        if (this.abortController) this.abortController.abort();
        this.input?.removeEventListener('input', this.onInput);
        this.input?.removeEventListener('search', this.onInput);
        this.input?.removeEventListener('pointerdown', this.onInputPointerDown);
        this.input?.removeEventListener('mousedown', this.onInputPointerDown);
        this.input?.removeEventListener('selectstart', this.onInputSelectStart);
        this.input?.removeEventListener('dblclick', this.onInputDoubleClick);
        this.input?.removeEventListener('keydown', this.onInputKeydown);
        this.panel?.removeEventListener('keydown', this.onPanelKeydown);
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        this.removeEventListener('focusout', this.onFocusOut);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onResize);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', this.onResize);
        }
      }

      get isOpen() {
        return Boolean(this.panel && !this.panel.hidden);
      }

      get isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      get hasSearchText() {
        return Boolean(this.input && this.input.value.trim().length >= this.minChars);
      }

      onInput() {
        const query = this.input.value.trim();
        this.lastQuery = query;
        clearTimeout(this.debounceTimer);

        if (query.length < this.minChars) {
          this.close(false);
          this.status.textContent = '';
          return;
        }

        this.debounceTimer = window.setTimeout(() => {
          this.fetchResults(query);
        }, 180);
      }

      async fetchResults(query) {
        const cacheKey = query.toLocaleLowerCase();

        if (this.cache.has(cacheKey)) {
          this.renderResults(query, this.cache.get(cacheKey));
          return;
        }

        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        this.renderLoading();
        this.open();

        const params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', String(this.maxResults));
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'hide');
        params.set('resources[options][fields]', 'title,product_type,tag,variants.title,vendor');

        const base = this.rootUrl.endsWith('/') ? this.rootUrl : `${this.rootUrl}/`;
        const url = `${base}search/suggest.json?${params.toString()}`;

        try {
          const response = await fetch(url, {
            signal: this.abortController.signal,
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) throw new Error(`Search request failed: ${response.status}`);

          const payload = await response.json();
          const products = payload?.resources?.results?.products || [];
          this.cache.set(cacheKey, products);

          if (this.input.value.trim() !== query) return;
          this.renderResults(query, products);
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.close(false);
        }
      }

      renderLoading() {
        this.panel.innerHTML = `
          <div class="bh-live-search__loading" aria-hidden="true">
            <div>
              <div class="bh-live-search__spinner"></div>
              <strong>Even zoeken…</strong>
            </div>
          </div>
        `;
      }

      renderResults(query, products) {
        const safeQuery = this.escapeHtml(query);
        const allUrl = `${this.searchUrl}?q=${encodeURIComponent(query)}&options%5Bprefix%5D=last`;

        if (!products.length) {
          this.panel.innerHTML = `
            <div class="bh-live-search__empty">
              <div>
                <strong>Geen directe match gevonden</strong>
                <span>Probeer een ander woord of bekijk alle zoekresultaten.</span>
              </div>
            </div>
            <div class="bh-live-search__footer">
              <a class="bh-live-search__all" href="${this.escapeAttr(allUrl)}" role="option">
                <span>Zoeken naar “${safeQuery}”</span>
                <span class="bh-live-search__all-arrow" aria-hidden="true">→</span>
              </a>
            </div>
          `;
          this.status.textContent = `Geen directe producten gevonden voor ${query}.`;
          this.open();
          return;
        }

        const items = products.map((product, index) => this.productMarkup(product, index)).join('');

        this.panel.innerHTML = `
          <div class="bh-live-search__heading" aria-hidden="true">
            <p class="bh-live-search__heading-title">Producten</p>
            <span class="bh-live-search__heading-count">${products.length} gevonden</span>
          </div>
          <div class="bh-live-search__list">
            ${items}
          </div>
          <div class="bh-live-search__footer">
            <a class="bh-live-search__all" href="${this.escapeAttr(allUrl)}" role="option">
              <span>Bekijk alle resultaten voor “${safeQuery}”</span>
              <span class="bh-live-search__all-arrow" aria-hidden="true">→</span>
            </a>
          </div>
        `;

        this.status.textContent = `${products.length} producten gevonden voor ${query}.`;
        this.open();
      }

      productMarkup(product, index) {
        const title = this.escapeHtml(product?.title || 'Product');
        const url = this.escapeAttr(product?.url || '#');
        const productType = product?.type ? this.escapeHtml(product.type) : '';
        const state = this.escapeHtml(this.getProductState(product));
        const image = product?.featured_image?.url || product?.image || '';
        const imageAlt = this.escapeAttr(product?.featured_image?.alt || product?.title || 'Productafbeelding');
        const imageMarkup = image
          ? `<img src="${this.escapeAttr(this.resizeImage(image, 160))}" alt="${imageAlt}" loading="lazy" width="160" height="160">`
          : `<svg class="bh-live-search__media-placeholder" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 7.5h14v11H5zM8 7.5V6a4 4 0 0 1 8 0v1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

        const price = this.toNumber(product?.price_min ?? product?.price);
        const compareMin = this.toNumber(product?.compare_at_price_min);
        const compareMax = this.toNumber(product?.compare_at_price_max);
        const compare = compareMin > price ? compareMin : (compareMax > price ? compareMax : 0);
        const hasDiscount = price > 0 && compare > price;
        const discount = hasDiscount ? Math.round((1 - price / compare) * 100) : 0;

        const metaParts = [
          `<span class="bh-live-search__state">${state}</span>`,
          hasDiscount ? `<span class="bh-live-search__discount">-${discount}%</span>` : '',
          productType ? `<span class="bh-live-search__type">${productType}</span>` : ''
        ].filter(Boolean).join('');

        return `
          <a
            class="bh-live-search__result"
            href="${url}"
            role="option"
            aria-selected="false"
            id="BhLiveSearchOption-${index}"
          >
            <span class="bh-live-search__media">${imageMarkup}</span>
            <span class="bh-live-search__content">
              <span class="bh-live-search__title">${title}</span>
              <span class="bh-live-search__meta">${metaParts}</span>
            </span>
            <span class="bh-live-search__prices">
              <span class="bh-live-search__price">${this.formatMoney(price)}</span>
              ${hasDiscount ? `<span class="bh-live-search__compare">${this.formatMoney(compare)}</span>` : ''}
            </span>
          </a>
        `;
      }

      getProductState(product) {
        const tags = Array.isArray(product?.tags) ? product.tags : [];
        const stateTag = tags.find((tag) => typeof tag === 'string' && tag.toLocaleLowerCase().startsWith('staat:'));
        if (!stateTag) return 'Retourdeal';
        const value = stateTag.slice(stateTag.indexOf(':') + 1).trim();
        return value || 'Retourdeal';
      }

      toNumber(value) {
        const number = Number.parseFloat(value);
        return Number.isFinite(number) ? number : 0;
      }

      formatMoney(value) {
        const language = document.documentElement.lang || 'nl-NL';
        const currency = window.Shopify?.currency?.active || 'EUR';
        try {
          return new Intl.NumberFormat(language, {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(value || 0);
        } catch (_) {
          return `€ ${Number(value || 0).toFixed(2).replace('.', ',')}`;
        }
      }

      resizeImage(src, width) {
        try {
          const url = new URL(src, window.location.origin);
          url.searchParams.set('width', String(width));
          return url.toString();
        } catch (_) {
          return src;
        }
      }

      escapeHtml(value) {
        return String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');
      }

      escapeAttr(value) {
        return this.escapeHtml(value);
      }

      open() {
        if (!this.panel) return;
        this.positionPanel();
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close(returnFocus = false) {
        if (!this.panel) return;
        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.clearSelection();
        if (returnFocus) this.input.focus();
      }

      positionPanel() {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const section = this.closest('.section-header') || this.closest('.header-wrapper');
        if (!section) return;
        const bottom = Math.max(0, Math.round(section.getBoundingClientRect().bottom));
        this.style.setProperty('--bh-live-panel-top', `${bottom}px`);
      }

      onResize() {
        if (this.isOpen) this.positionPanel();
      }

      onDocumentPointerDown(event) {
        if (this.contains(event.target)) return;

        /*
         * Desktop: buiten de zoekbalk klikken sluit de resultaten.
         * Mobiel: resultaten blijven zichtbaar zolang er een geldige zoekterm
         * in het veld staat. Het sluiten van het toetsenbord mag ze dus niet sluiten.
         */
        if (!this.isMobile || !this.hasSearchText) {
          this.close(false);
        }
      }

      onFocusOut() {
        window.setTimeout(() => {
          if (this.contains(document.activeElement)) return;

          /*
           * Op mobiel veroorzaakt het sluiten van het softwaretoetsenbord blur/focusout.
           * Zolang de zoekterm nog aanwezig is, blijven de resultaten open.
           */
          if (this.isMobile && this.hasSearchText) {
            if (this.panel && this.panel.innerHTML.trim()) this.open();
            return;
          }

          this.close(false);
        }, 0);
      }

      onInputPointerDown(event) {
        /* Geen preventDefault: dan zou tekstselectie juist onmogelijk worden.
           Alleen voorkomen dat een externe header/theme-listener de klik overneemt. */
        event.stopPropagation();
      }

      onInputSelectStart(event) {
        /* Laat de browser selecteren, maar laat selectstart niet doorbubbelen
           naar eventuele globale theme-listeners. */
        event.stopPropagation();
      }

      onInputDoubleClick(event) {
        if (!this.input) return;

        event.stopPropagation();

        /* De browser voert zijn eigen dubbelklik-selectie pas na het event uit.
           Daarom zetten we onze selectie in de volgende task: zo kan die niet
           direct weer door browser- of theme-gedrag worden overschreven. */
        window.setTimeout(() => {
          if (!this.input || !this.input.isConnected) return;

          try {
            this.input.focus({ preventScroll: true });
          } catch (_) {
            this.input.focus();
          }

          const length = this.input.value.length;
          if (!length) return;

          try {
            this.input.setSelectionRange(0, length, 'forward');
          } catch (_) {
            this.input.select();
          }
        }, 0);
      }

      onInputKeydown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault();
          this.close(false);
          return;
        }

        /*
         * Op telefoons betekent Enter/Zoeken/Gereed:
         * toetsenbord sluiten, maar live resultaten laten staan.
         * Tikken op het vergrootglas blijft wel de volledige zoekpagina openen.
         */
        if (event.key === 'Enter' && this.isMobile && this.hasSearchText) {
          event.preventDefault();
          this.input.blur();

          window.setTimeout(() => {
            if (this.hasSearchText && this.panel && this.panel.innerHTML.trim()) {
              this.open();
            }
          }, 60);

          return;
        }

        if (event.key === 'ArrowDown' && this.isOpen) {
          const options = this.getOptions();
          if (options.length) {
            event.preventDefault();
            this.selectOption(options[0]);
          }
        }
      }

      onPanelKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close(true);
          return;
        }

        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;

        const options = this.getOptions();
        if (!options.length) return;

        const currentIndex = options.indexOf(document.activeElement);
        event.preventDefault();

        if (event.key === 'ArrowDown') {
          const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
          this.selectOption(options[nextIndex]);
        } else if (currentIndex <= 0) {
          this.clearSelection();
          this.input.focus();
        } else {
          this.selectOption(options[currentIndex - 1]);
        }
      }

      getOptions() {
        return Array.from(this.panel.querySelectorAll('[role="option"]'));
      }

      selectOption(option) {
        this.clearSelection();
        option.setAttribute('aria-selected', 'true');
        option.focus();
      }

      clearSelection() {
        this.getOptions().forEach((option) => option.setAttribute('aria-selected', 'false'));
      }
    }

    customElements.define('budgetheld-live-search', BudgetheldLiveSearch);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.scrollThreshold = 4;
      this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.lastDirection = null;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.predictiveSearch = this.querySelector('budgetheld-live-search, predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);

      this.setHeaderHeight();
      this.header.classList.add('shopify-section-header-sticky');

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });

      this.header.addEventListener('focusin', () => this.reveal());
      this.header.addEventListener('pointerenter', () => {
        if (window.matchMedia('(hover: hover)').matches) this.reveal();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      const delta = scrollTop - this.lastScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.reveal();
        this.lastScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= 8) {
        this.reset();
        this.lastScrollTop = scrollTop;
        this.lastDirection = null;
        return;
      }

      if (Math.abs(delta) < this.scrollThreshold) return;

      if (delta > 0) {
        if (this.lastDirection !== 'down') this.lastDirection = 'down';
        this.header.classList.add('scrolled-past-header');
        this.hide();
      } else {
        if (this.lastDirection !== 'up') this.lastDirection = 'up';
        this.header.classList.add('scrolled-past-header');
        this.reveal();
      }

      this.lastScrollTop = scrollTop;
    }

    hide() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
